import styled from "styled-components";
import { ReactSVG } from "react-svg";
import { windowWidth } from "@styles/global";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModuleIcon = styled(ReactSVG)`
  > :first-child {
     height: 20px;
     display: flex;
     align-items: center;
     justify-content: center;
     flex-direction: row;

     svg {
         width: 100%;
         height: 100%;
     }
   }

  @media ( max-width: ${windowWidth.laptop.large} ) {
    > :first-child {
        height: calc(20px * 0.9);
    }
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    > :first-child {
      height: calc(20px * 0.8);
    }
  }

  @media ( max-width: ${windowWidth.mobile.small} ) {
    > :first-child {
      height: calc(20px * 0.6);
    }
  }
`;

export { Container, ModuleIcon };
